import { getCurrentLang } from './core';

type FormatNumberParams = Intl.NumberFormatOptions;
export const formatNumber = (value: number, options: FormatNumberParams) => {
  const locale = getCurrentLang();

  return new Intl.NumberFormat(locale, options).format(value);
};
